import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { completeTask, createUploadTask } from '@blade-sxp/ota-management/api/index';
import { splitFile, SendBinaryDataUtil, calculateMD5 } from '@blade-sxp/ota-management/pages/utils';
import { forEach, map, reduce } from 'lodash';
import { debounceByRequestAnimationFrame } from '@blade/common/utils/function-enhance';
const CHUNKSIZE = 1024 * 1024 * 5;
let default_1 = class default_1 extends Vue {
    originFile;
    onUploadToFileServerSuccess;
    upload_id = '';
    registry_id = 'default';
    bucket_name = 'ota-package-bucket';
    percentage = 0;
    requestList = [];
    status = '';
    chunkList = [];
    async mounted() {
        this.generateMD5();
        await this.processFile();
        this.uploadChunks();
    }
    async generateMD5() {
        const md5 = await calculateMD5(this.originFile, CHUNKSIZE);
        this.$emit('update:md5', md5);
    }
    async processFile() {
        this.chunkList = await splitFile(this.originFile, CHUNKSIZE);
    }
    onRetryClick() {
        this.reset();
        setTimeout(() => {
            this.uploadChunks();
        }, 1000); // 等进度条动画执行结束
    }
    onCancelClick() {
        this.onCancel();
        this.$emit('onUploadCanceled');
    }
    reset() {
        this.percentage = 0;
        this.status = '';
        forEach(this.chunkList, (chunkItem) => {
            chunkItem.loaded = 0;
        });
    }
    onCancel() {
        forEach(this.requestList, (request) => request.abort());
        this.requestList = [];
        this.reset();
    }
    onprogressCallback(index) {
        return (e) => {
            const { loaded } = e;
            this.chunkList[index].loaded = loaded;
            this.updateProgressDebounced();
        };
    }
    updateProgress() {
        const currentProcessedSize = reduce(this.chunkList, (pre, item) => {
            return pre + (item.loaded || 0);
        }, 0);
        this.percentage = Number(((currentProcessedSize / this.originFile.size) * 100).toFixed(2));
    }
    updateProgressDebounced = debounceByRequestAnimationFrame(this.updateProgress);
    async uploadChunks() {
        const { data: { upload_id }, } = await createUploadTask(this.originFile.name);
        this.upload_id = upload_id;
        try {
            const object_name = this.originFile.name;
            this.requestList = [];
            const taskList = map(this.chunkList, (item, index) => {
                const headers = {
                    registry_id: this.registry_id,
                    bucket_name: this.bucket_name,
                    object_name,
                    part_number: index + 1,
                    upload_id: this.upload_id,
                    content_md5_base64: '',
                    content_length: item.size,
                    content_sha256_hex: '',
                    uploaded: item.uploaded || false, // TODO uploaded
                };
                const request = new SendBinaryDataUtil(`/upload/v1/registries/default/multipart_upload/${this.upload_id}`, JSON.stringify(headers), 'PUT');
                this.requestList.push(request);
                return request.sendData(item.chunk, this.onprogressCallback(index)).then((res) => {
                    const response = JSON.parse(res?.target?.response);
                    item.part_info = response?.part_info;
                });
            });
            await Promise.all(taskList);
            await completeTask({ upload_id: this.upload_id, object_name, complete_parts: map(this.chunkList, 'part_info') });
            this.requestList = [];
            await this.onUploadToFileServerSuccess();
            this.status = 'success';
            this.$elmessage.success(this.$t('common.success').toString());
        }
        catch (e) {
            this.status = 'exception';
            if (String(e) !== 'Error: abort' && String(e) !== '[object ProgressEvent]') {
                this.$elmessage.error(String(e));
            }
            else if (String(e) === '[object ProgressEvent]') {
                this.$elmessage.error(this.$t('common.unknownError').toString());
            }
        }
    }
    beforeDestroy() {
        this.onCancel();
    }
};
__decorate([
    Prop()
], default_1.prototype, "originFile", void 0);
__decorate([
    Prop()
], default_1.prototype, "onUploadToFileServerSuccess", void 0);
default_1 = __decorate([
    Component({
        name: 'upload-progress',
        i18n: {
            messages: {
                'en-us': {
                    processing: 'processing',
                    uploading: 'uploading',
                    cancel: 'Cancel',
                    retry: 'Upload Again',
                },
                zh: {
                    cancel: '取消上传',
                    retry: '重新上传',
                },
            },
        },
    })
], default_1);
export default default_1;
